import React from 'react';
import ReactMarkdown from 'react-markdown';
import { HiOutlineDocumentText } from 'react-icons/hi';
import technicalDetailsMarkdown from '../../../content/fleetTechnicalDetails.md';

const resolveMarkdownAssetUrl = (src) => {
  if (!src) return src;
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('//')) return src;
  if (src.startsWith('data:') || src.startsWith('blob:')) return src;
  if (src.startsWith('/')) return `${process.env.PUBLIC_URL || ''}${src}`;
  return src;
};

const TechnicalDetails = () => {
  const markdownContent = technicalDetailsMarkdown;

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <div className="prose prose-lg max-w-none">
        <ReactMarkdown
          components={{
                h1: ({ children }) => (
                  <h1 className="text-3xl font-bold text-gray-800 mb-4 flex items-center gap-3">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <HiOutlineDocumentText size={24} className="text-blue-600" />
                    </div>
                    {children}
                  </h1>
                ),
                h2: ({ children }) => (
                  <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 border-b border-gray-200 pb-2">
                    {children}
                  </h2>
                ),
                h3: ({ children }) => (
                  <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">
                    {children}
                  </h3>
                ),
                h4: ({ children }) => (
                  <h4 className="text-lg font-medium text-gray-800 mt-4 mb-2">
                    {children}
                  </h4>
                ),
                p: ({ children }) => (
                  <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                    {children}
                  </p>
                ),
                ul: ({ children }) => (
                  <ul className="list-disc list-outside pl-6 text-gray-600 mb-4 space-y-1">
                    {children}
                  </ul>
                ),
                ol: ({ children }) => (
                  <ol className="list-decimal list-outside pl-6 text-gray-600 mb-4 space-y-1">
                    {children}
                  </ol>
                ),
                li: ({ children }) => (
                  <li className="text-gray-600">
                    {children}
                  </li>
                ),
                img: ({ src, alt }) => (
                  <div className="my-6 text-center">
                    <img
                      src={resolveMarkdownAssetUrl(src)}
                      alt={alt || 'Image'}
                      className="max-w-full h-auto mx-auto"
                    />
                  </div>
                ),
                a: ({ href, children }) => (
                  <a
                    href={href}
                    className="text-blue-600 hover:text-blue-800 underline"
                    target={href?.startsWith('http') ? '_blank' : undefined}
                    rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    {children}
                  </a>
                ),
                hr: () => (
                  <hr className="my-8 border-gray-200" />
                ),
                em: ({ children }) => (
                  <em className="text-gray-500 text-sm italic text-center block my-2">
                    {children}
                  </em>
                ),
          }}
        >
          {markdownContent}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default TechnicalDetails;
